import { IGetSuperuserWorkspaceSwitcherResponseDto, IGetWorkspaceSwitcherResponseDto, Products } from '@site-mate/sitemate-global-shared/lib';

import { GlobalApiClient } from './global-api.client';

interface ICheckWorkspaceMigrationEligibilityParams {
  fromAccountId: string;
  toAccountId: string;
}
async function checkWorkspaceMigrationEligibility(params: ICheckWorkspaceMigrationEligibilityParams) {
  const res = await GlobalApiClient.get(`/workspaces/validate/account-change-eligibility`, {
    params,
  });

  return res.data;
}

async function isSSODomain(domain: string): Promise<{ isSSODomain: boolean }> {
  const res = await GlobalApiClient.get(`/workspaces/sso-domain/verify/${domain}`);
  return res.data;
}

async function searchWorkspacesForSuperuser(query: string) {
  const res = await GlobalApiClient.get<IGetSuperuserWorkspaceSwitcherResponseDto[]>(`/workspaces/search`, {
    params: {
      query,
    },
  });

  return res.data;
}

async function getWorkspacesForRegularUser() {
  const res = await GlobalApiClient.get<IGetWorkspaceSwitcherResponseDto[]>(`/workspaces/access`);

  return res.data;
}

async function getWorkspacesByAccountId(accountId: string) {
  const res = await GlobalApiClient.get<{
    accountId: string;
    accountName: string;
    workspaces: Array<{
      id: string;
      name: string;
      product: Products;
      logo?: string;
      legacyId?: string | null;
      region?: string | null;
      subdomain?: string | null;
    }>;
  }>(`/workspaces/account/${accountId}`);

  const { accountName, workspaces } = res.data;
  return workspaces.map<IGetWorkspaceSwitcherResponseDto>((ws) => ({
    workspaceId: ws.id,
    accountId,
    accountName,
    name: ws.name,
    product: ws.product,
    logo: ws.logo,
    legacyId: ws.legacyId,
    region: ws.region,
    subdomain: ws.subdomain,
  }));
}

async function checkForBannedOrReservedWords(workspaceName: string): Promise<{ isValidWorkspaceName: boolean }> {
  const res = await GlobalApiClient.get(`/workspaces/validate/name?name=${workspaceName}`);
  return res.data;
}

async function isBusinessDomainInUse(domain: string): Promise<{ isBusinessDomainInUse: boolean }> {
  const res = await GlobalApiClient.get(`/workspaces/business-domain/${domain}`);
  return res.data;
}

export const workspaceService = {
  checkWorkspaceMigrationEligibility,
  isSSODomain,
  checkForBannedOrReservedWords,
  searchWorkspacesForSuperuser,
  getWorkspacesForRegularUser,
  getWorkspacesByAccountId,
  isBusinessDomainInUse,
};
